import api from "../../../api/axios";

// Thin call-wrapper around GET /api/companies/?search=<q>&page=1.
// DRF SearchFilter performs case-insensitive icontains on
// CompanyViewSet.search_fields = ("name", "description", "city").
// Returns the raw paginated envelope { count, next, previous, results }.
export const searchCompanies = (query, { signal } = {}) =>
  api
    .get("/companies/", {
      params: { search: query, page: 1 },
      signal,
    })
    .then((res) => res.data);
